import { useState, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useGetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';

import { SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE } from '../Controller';

export function useSpotlightState(spotlightKey: string) {
	const [isSpotlightActive, setIsSpotlightActive] = useState(false);
	const { data, loading, error: spotlightError } = useGetOnboardingState(spotlightKey);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (data && !loading && !spotlightError) {
			const spotlightSeen =
				data?.onboardingState?.find((prop) => prop.key === spotlightKey)?.value === 'true';

			if (!spotlightSeen) {
				setIsSpotlightActive(true);
			}
		}
	}, [data, loading, spotlightError, spotlightKey]);

	useEffect(() => {
		if (spotlightError && !loading) {
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					source: SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE,
					actionSubject: spotlightKey,
					action: 'spotlight failed',
				},
			}).fire();
		}
	}, [spotlightKey, spotlightError, loading, createAnalyticsEvent]);

	return { isSpotlightActive };
}
